export default __webpack_public_path__ + "static/media/11.98d2cce9.jpg";